import styled from "styled-components";
import milestone from "../images/milestone.jpg";
const Wrapper = styled.div`
  background: linear-gradient(rgba(19, 33, 60, 0.95), rgba(19, 33, 60, 0.9)),
    url(${milestone});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 40px 0;

  @media (min-width: 768px) {
    background-attachment: fixed;
  }

  @media (max-width: 600px) {
    margin-top: 20px;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 20px 10px;
    gap: 30px;
    @media (max-width: 600px) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      text-align: center;
      padding: 20px 10px;
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 1.5rem;
      color: #f9f9f9;
      font-weight: 500;
      p {
        font-size: 2.2rem; /* Slightly larger for impact */
        color: var(--secondary-color); /* Gold for visibility */
        font-weight: 800; /* Extra bold */
        font-family: 'Playfair Display', serif;
        margin-bottom: 5px;
        text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

        @media (max-width: 760px) {
          font-size: 1.8rem;
        }
      }

      .divider {
        height: 2px;
        width: 40px;
        background-color: var(--secondary-color);
        border: none;
        opacity: 0.6;
      }

      span {
        font-size: 1.2rem;

        @media (max-width: 760px) {
          font-size: 1.1rem;
        }

        @media (max-width: 600px) {
          width: 120px;
        }
      }
    }
  }
`;

export default Wrapper;
